<template>
    <div>
        <form class="uploader-box" autocomplete="off" @submit.prevent="" scope="form">
            <div class="row">
                <div class="col-12">
                    <div v-html="msgUpload"></div>
                    <slot name="aftermsg">
                        <div class="form-group" v-if="showHelp">
                            <a href="#" @click.prevent="openNotes">
                                {{ $t(`${idPanel}.help.uploadInfoLink`) }}
                            </a>
                        </div>
                    </slot>
                    <div class="form-group">
                        <label
                            class="btn btn-silver btn-rounded btn-sm mx-0 mb-2"
                            :class="{'disabled': limitExceeded}"
                            :title="$t(`${idPanel}.form.addFile`)">
                            {{ $t(`${idPanel}.form.files`) }} <i class="pl-1 fas fa-plus"></i>
                            <input type="file"
                                :name="idUpload"
                                :ref="idUpload"
                                :accept="acceptTypes"
                                :multiple="multiple"
                                @change="uploadFieldChange"
                                :disabled="limitExceeded">
                        </label>
                        <div class="d-flex flex-wrap align-items-center">
                            <div
                                class="item pl-sm-3"
                                v-for="(item, index) in files"
                                :key="`file-${index}`"
                                >
                                <div
                                    class="delete mr-3 d-inline"
                                    :title="$t(`${idPanel}.form.removeFile`)"
                                    @click.prevent="removeFileLoaded(index)">
                                    <i class="fas fa-times"></i>
                                </div>
                                <i class="far fa-file-alt d-inline"></i><span class="d-inline"> - {{item.name}}</span>
                            </div>
                            <small v-if="isSizeRestrictive && (!files || files.length==0)" class="">
                                {{ $t(`${idPanel}.help.maxFiles`, { num: maxFiles}) }}
                            </small>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="city-form-group">
                            <input
                                type="hidden"
                                name="files"
                                v-model="files"
                                v-validate="{'required': minFiles>0, 'minElements': minFiles}"
                                :data-vv-scope="'form'" />
                            <small
                                class="invalid-feedback"
                                :class="[fnHasError('files') ? 'd-block' : '']">
                                {{ fnFirstError('files') }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 col-sm-6">
                            <button
                                :disabled="disabled || loading || !hasFiles"
                                class="btn btn-outline-tertiary btn-rounded btn-sm btn-responsive btn-block min-w-auto"
                                type="button"
                                @click.prevent="uploadFiles">
                                {{ buttons['upload'] }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- <upload-geofiles-notes
            v-if="showHelp"
            :showModal="showModalNotes"
            :propertyNameFilter="propertyNameFilter"
            :propertyBoundaryFilterTitle="propertyBoundaryFilterTitle"
            :propertyBoundaryFilter="propertyBoundaryFilter"
            :propertyClaimFilterTitle="propertyClaimFilterTitle"
            :propertyClaimFilter="propertyClaimFilter"
            @close="showModalNotes=false"
         /> -->
    </div>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';
import { isArray } from '@config/utils';

export default {
    mixins: [
        GlobalMixin
    ],
    components:{
        // UploadGeofilesNotes: () => import(/* webpackChunkName: "upload-geofiles-notes" */ './UploadGeoFilesNotes'),
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        titleCtrl: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        multiFilesFormats: {
            type: Array,
            default: () => ([
                'shp',
                'tab',
            ]),
        },
        formats: {
            type: Array,
            default: () => ([
                'shp',
                'tab',
                'kml',
                'gml',
                'gpx',
            ]),
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        maxFiles: {
            type: Number,
            default: 3,
        },
        minFiles:{
            type: Number,
            default: 1
        },
        propertyNameFilter:{
            type: Array,
            default: () => {
                return [];
            },
        },
        propertyFilterTitle: {
            type: String,
            default: null,
        },
        propertyFilter:{
            value: [String, Array],
        },
        maxFeatures: {
            type: Number,
            default: 0,
        },
        propertyBoundaryFilterTitle: {
            type: String,
            default: 'Geometrias',
        },
        propertyBoundaryFilter:{
            value: [String, Array],
        },
        maxFeaturesBoundary: {
            type: Number,
            default: 1,
        },
        propertyClaimFilterTitle: {
            type: String,
            default: 'Implantação',
        },
        propertyClaimFilter:{
            value: [String, Array],
        },
        maxFeaturesClaim: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            idPanel: 'uploadgeofiles',
            idUpload: 'uploadInput',
            loading: false,
            showModalNotes: false,
            files: [],
        }
    },
    computed: {
        buttons(){
            return {
                upload: this.$t(`${this.idPanel}.buttons.upload`),
            };
        },
        showHelp() {
            return (this.propertyNameFilter && this.propertyNameFilter.length>0)
                || !!this.propertyBoundaryFilter || !!this.propertyClaimFilter;
        },
        isSizeRestrictive() {
            return this.maxFiles == 0 || this.maxFiles  == Number.MAX_VALUE ? false : this.maxFiles > 0;
        },
        limitExceeded(){
            return this.isSizeRestrictive ? this.files.length >= this.maxFiles : false;
        },
        hasFiles(){
            return this.files.length > 0;
        },
        supportedMulti(){
            let supported = [];
            this.multiFilesFormats.forEach((format, index) => {
                if (this.formats.includes(format)) {
                    supported.push(format);
                }
            });
            return supported;
        },
        acceptTypes() {
            let formats = [...this.formats];
            if(formats.length > 0 && this.supportedMulti.length > 0) {
                formats.push('zip');
            }
            return formats.length ? ('.' + formats.join(',.')) : '';
        },
        msgUpload(){
            let msgArray = [
                this.$t(`${this.idPanel}.form.msg`, {
                    formats: this.formats.filter( f => !['zip', 'xml'].includes(f.toLowerCase()) ).join("</b>, <b>").toUpperCase()
                })
            ];
            if(this.supportedMulti.length > 0) {
                let last = this.supportedMulti.pop().toUpperCase();
                msgArray.push('<p>');
                msgArray.push(this.$t(`${this.idPanel}.form.msgSupportMulti`));
                if (this.supportedMulti.length > 0) {
                    msgArray = msgArray.concat([
                        this.supportedMulti.join(', ').toUpperCase(),
                        " ",
                        this.$t(`${this.idPanel}.form.msgSupportMultiSeparator`),
                        " "
                    ]);
                }
                msgArray.push(last + '.');
                msgArray.push('</p>');
                msgArray.push('<p>' + this.$t(`${this.idPanel}.form.msgTopologicValidation`) + '</p>');
            }
            return msgArray.join('');
        },
        notesHtml() {
            let txt = `<div class="city-form-group notes-block">
                        <p class="title">
                            ${this.$t(`${this.idPanel}.form.notes.title`)}
                        </p>
                        <ul class="">
                            ${this.notesItemsHtml}
                        </ul>
                    </div>`;

            return txt;
        },
        notesItemsHtml() {
            let items = [];
            if(this.propertyFilter || this.propertyFilterTitle) {
                items.push({
                    title: this.propertyFilterTitle,
                    propertyName: this.labelPropertyNameFilter,
                    propertyValue: this.notesValuePropertyFilter(this.propertyFilter),
                    maxFeatures: this.notesLabelMaxFeatures(this.maxFeatures),
                });
            }
            if(this.propertyBoundaryFilter) {
                items.push({
                    title: this.propertyBoundaryFilterTitle,
                    propertyName: this.labelPropertyNameFilter,
                    propertyValue: this.notesValuePropertyFilter(this.propertyBoundaryFilter),
                    maxFeatures: this.notesLabelMaxFeatures(this.maxFeaturesBoundary),
                });
            }
            if(this.propertyClaimFilter) {
                items.push({
                    title: this.propertyClaimFilterTitle,
                    propertyName: this.labelPropertyNameFilter,
                    propertyValue: this.notesValuePropertyFilter(this.propertyClaimFilter),
                    maxFeatures: this.notesLabelMaxFeatures(this.maxFeaturesClaim),
                });
            }

            let txt = [];
            items.forEach(item => {
                let hasParent = !!item.title;
                let strList = hasParent ? ['<li class="mb-3">', `<span> ${item.title}</span>`, '<ul class="">'] : [];
                if(item.maxFeatures) strList.push(`<li> ${item.maxFeatures} </li>`)
                if(item.propertyName) strList.push(`<li> ${item.propertyName} </li>`)
                if(item.propertyValue) strList.push(`<li> ${item.propertyValue} </li>`)
                txt.push(strList.concat(hasParent ? [`</ul>`, `</li>`] : []).join(''));
            });
            return txt.join('');
        },
        labelPropertyNameFilter() {
            return this.$t(`${this.idPanel}.help.labelPropertyNameFilter`, { properties: this.propertyNameFilter.join(', ')});
        },
        propertiesFilter() {
            return this.propertyNameFilter.filter(n => n).join(',');
        },
        valuesFilter() {
            return [
                ...(isArray(this.propertyFilter) ? this.propertyFilter : [this.propertyFilter]),
                ...(isArray(this.propertyBoundaryFilter) ? this.propertyBoundaryFilter : [this.propertyBoundaryFilter]),
                ...(isArray(this.propertyClaimFilter) ? this.propertyClaimFilter : [this.propertyClaimFilter]),
            ].filter(n => n).join(',');
        },
    },
    mounted() {

    },
    async beforeDestroy() {

    },
    methods: {
        reset: function() {
            Object.assign(this.$data.files, this.$options.data().files);
            this.resetInputField();
            this.files = [];
            this.resetValidator();
        },
         uploadFieldChange: function(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return false;
            }
            this.addFiles(files);
        },
        addFiles: function(files) {
            const amount = files.length;
            if (this.isSizeRestrictive && amount > this.maxFiles) {
                return false;
            }

            // process all File objects
            for (let i = 0, len = files.length; i < len; i++) {
                const file = files[i];
                if(this.verifyMaxUploadSize(file.size)) {
                    this.showError(this.$t(`${this.idPanel}.form.maxUploadFile`, { max: this.maxUploadSize}), this.titleCtrl);
                    continue;
                }
                this.createFile(file);

                if (!this.multiple) {
                    break;
                }
            }

            this.resetInputField();
        },
        createFile(file) {
            let reader = new FileReader();
            let formData = new FormData();
            formData.append('file', file);

            reader.onload = (e) => {
                let dataURI = e.target.result;
                if (dataURI && !this.files.find(f => f.name === file.name && f.path===dataURI)) {
                    this.files.push({ name: file.name, file: file, path: dataURI});
                }
            };

            reader.onerror = (e) => {
                console.error("File could not be read! Code " + e.target.error.code);
            };
            // Reading data URIs
            reader.readAsDataURL(file);
        },
        removeFileLoaded: function(index) {
            this.files.splice(index, 1);
            this.resetInputField();
        },
        resetInputField: function(){
            const input = this.$refs[this.idUpload]
            if (input) {
                input.type = 'text';
                input.type = 'file';
                input.value = "";
            }
            this.$emit('filesChanged');
        },
        uploadFiles: function() {
            this.$emit('beforeUpload');

            this.$validator.validateAll('form')
            .then( result => {
                if(!result) {
                    this.showError(this.$t('global.msg.error.form'), this.titleCtrl);
                    return;
                }

                if(this.files.length > 0) {
                    this.loading = true;

                    let formData = new FormData();
                    formData.append("prop", this.propertiesFilter);
                    formData.append("val", this.valuesFilter);
                    formData.delete('geofiles');
                    for (var x = 0; x < this.files.length; x++) {
                        formData.append("geofiles[]", this.files[x].file);
                    }

                    this.$http.post(
                        this.url,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then( res => {
                        let data = res.data.data;
                        if(data && data.geojson){
                            // this.drawUploadEntities(data.geojson).then((value) => console.log(value));
                            this.$emit('uploaded', data.geojson);
                            this.reset();
                        }else{
                            this.showError(data);
                        }
                    }).catch( error => {
                        this.showHttpError(error);
                    }).finally(() => {
                        this.loading = false;
                    })
                }

            });
        },
        openNotes() {
            this.$root.$emit('openInfo', {
                title: this.$t(`${this.idPanel}.title`),
                html: this.notesHtml,
                callback: (itemId, grp_name) => {

                },
            });
        },
        notesLabelMaxFeatures(num) {
            return this.$tc(`${this.idPanel}.form.notes.maxFeatures`, num, { num: num});
        },
        notesValuePropertyFilter(prop) {
            return isArray(prop) && prop.length || !isArray(prop) && prop ?
                this.$t(`${this.idPanel}.form.notes.valuePropertyFilter`, { prop: isArray(prop) ? prop.join(', ') : prop}) : '';
        },
    },
    watch: {

    },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
}

.uploader-box {
    .delete {
        cursor: pointer;
    }
}
</style>